import {cmps} from './constantes';

const fechaActual = new Date();
export const esquemaCampos = {
   [cmps.RUC]: {valor: '', error: ''},
   [cmps.RAZON_SOCIAL]: {valor: '', error: ''},
   [cmps.TIPO_DOC]: {valor: '01', error: ''},
   [cmps.SERIE_DOC]: {valor: '', error: ''},
   [cmps.NRO_DOC]: {valor: '', error: ''},
   [cmps.PRODUCTO]: {valor: '', error: ''},
   [cmps.VERSION]: {valor: '', error: ''},
   [cmps.PRESENTACION]: {valor: '', error: ''},
   [cmps.MODULAR]: {valor: '', error: ''},
   [cmps.ANIO]: {valor: fechaActual.getFullYear(), error: ''},
   [cmps.FECHA_EXPIRACION]: {valor: null, error: ''},
   [cmps.FECHA_VIGENCIA_API]: {valor: null, error: ''},
   [cmps.FECHA_VIGENCIA_SOPORTE]: {valor: null, error: ''},
   //agregar fecha de vigencia para apis
   [cmps.COD_ACTIVACION]: {valor: '', error: ''}
};

export const esquemaValidacion = {
   [cmps.RUC]: {
      requerida: true
   },
   [cmps.RAZON_SOCIAL]: {
      requerido: true
   },
   [cmps.TIPO_DOC]: {
      requerido: true
   },
   [cmps.SERIE_DOC]: {
      requerido: true
   },
   [cmps.NRO_DOC]: {
      requerido: true
   },
   [cmps.PRODUCTO]: {
      requerido: true
   },
   [cmps.VERSION]: {
      requerido: true
   },
   [cmps.PRESENTACION]: {
      requerido: true
   },
   [cmps.ANIO]: {
      requerido: true,
      validador: {
         cast: valor => {
            return parseInt(valor);
         }
      }
   },
   [cmps.FECHA_EXPIRACION]: {
      requerido: false
   },
   [cmps.FECHA_VIGENCIA_API]: {
      requerido: false
   },
   [cmps.FECHA_VIGENCIA_SOPORTE]: {
      requerido: false
   },
   //agregar fecha de vigencia para apis
   [cmps.COD_ACTIVACION]: {
      requerido: true
   }
};
